module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-17.72738885.jpg";